import React, { useContext, useRef, useState } from "react";
import { CustomText, Input, InputDate } from "../../components";
import { FormFull } from "form-full";
import { fonts } from "../../config";

import { alerts, hooks, masks, validations } from "../../utils";

import { CircularProgress } from "@mui/material";

import { HomeWork, Visibility } from "@mui/icons-material";
import { customModal, errorModal } from "../../components/modals/utils";
import { api } from "../../services";
import { useLocation, useParams } from "react-router-dom";
import ReservationForm from "./components/ReservationForm";
import GuestForm from "./components/GuestForm";
import { StylesForm } from "./styles";
import { StorageContext } from "../../contexts/StorageContext";
import VisitantForm from "./components/VisitantForm";
import TenantForm from "./components/TenantForm";
import ServiceProviderForm from "./components/ServiceProviderForm";
import ReservationFormADMIN from "./components/ReservationFormAdmin";

export function checkBirthday(birthday: string) {
  if (birthday != undefined && birthday.length > 9) {
    const now: Date = new Date();
    const birthdayDate: Date = new Date(birthday);
    const answer = birthdayDate > now;
    return answer;
  } else {
    return false;
  }
}

function Home() {
  const location = useLocation();
  const { loading, call } = hooks.useRequest();
  const [isMounted, setMount] = React.useState<any>(false);
  const [type, setType] = React.useState<any>(null);
  const [data, setData] = React.useState<any>(null);
  const [success, setSuccess] = React.useState<any>(false);
  const { dataAp, setDataAp } = useContext<any>(StorageContext);
  const { dataSP, setDataSP } = useContext<any>(StorageContext);
  const [role, setRole] = useState<any>(null);

  const queryParams = new URLSearchParams(location.search);
  const Mount = React.useCallback(() => {
    if (queryParams.get("id") && queryParams.get("renterId")) {
      call(
        "reservation",
        api.getReservation({
          reservationId: queryParams.get("id"),
          renterId: queryParams.get("renterId"),
        }),
        async (response) => {
          if (response.ok) {
            let imgPrimary: any = null;
            let secondaryGuests: any = [...response.data?.secondaryGuests];
            let mainGuest: any = null;

            setRole(response.data.subType);
            if (response.data?.primaryGuest?.imageId) {
              await call(
                null,
                api.getImage(response.data?.primaryGuest?.imageId),
                async (rImage) => {
                  if (rImage.ok) {
                    imgPrimary = rImage.data;
                  }
                }
              );
            }

            if (
              response?.data?.primaryGuest?.id === queryParams.get("renterId")
            ) {
              for (const item of secondaryGuests) {
                if (item.imageId) {
                  await call(
                    null,
                    api.getImage(item.imageId),
                    async (rImage) => {
                      if (rImage.ok) {
                        item.image = rImage.data;
                      }
                    }
                  );
                }
              }
            } else {
              for (const item of secondaryGuests) {
                if (item.id === queryParams.get("renterId")) {
                  if (item.imageId) {
                    await call(
                      null,
                      api.getImage(item.imageId),
                      async (rImage) => {
                        if (rImage.ok) {
                          secondaryGuests = { ...item, image: rImage.data };
                        } else {
                          secondaryGuests = { ...item, image: null };
                        }
                      }
                    );
                  } else {
                    secondaryGuests = item;
                  }
                }
              }
            }

            setData({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              otherGuests: response.data.secondaryGuests.filter(
                (item) => item.id !== queryParams.get("renterId")
              ),
              renterId: queryParams.get("renterId"),
            });

            setDataAp({
              ...response.data,
              primaryGuest: {
                ...response.data.primaryGuest,
                image: imgPrimary,
              },
              secondaryGuests: secondaryGuests,
              otherGuests: response.data.secondaryGuests.filter(
                (item) => item.id !== queryParams.get("renterId")
              ),
              renterId: queryParams.get("renterId"),
            });
          }
        }
      );
    }
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  function removerBase64EAntes(texto) {
    if (!texto) return null;

    const indiceBase64 = texto.indexOf("base64,");

    if (indiceBase64 !== -1) {
      return texto.substring(indiceBase64 + 7);
    }

    return texto;
  }

  const onSubmit = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      if (data.renterId === data?.primaryGuest?.id) {
        let submitData = [
          {
            id: data.primaryGuest.id,
            name: formData.fullName,
            document: formData.docType === 1 ? formData.docValue : undefined,
            birthDate: formData.birthday
              ? masks.dataParaString(formData.birthday)
              : null,
            email: formData.email,
            phone: formData.phone,
            image: removerBase64EAntes(formData.file.current.base),
            passport: formData.docType === 2 ? formData.docValue : undefined,
            vehiclePlate: formData.vehiclePlate
              ? formData.vehiclePlate
              : undefined,
          },
        ];
        try {
          const secondary = Number.parseInt(formData.number);
          if (secondary > data.secondaryGuests.length) {
            for (
              let index = data.secondaryGuests.length;
              index < secondary;
              index++
            ) {
              data.secondaryGuests.push({ id: undefined });
            }
          }
        } catch (error) {
          console.log(error);
        }
        for (let index = 0; index < data.secondaryGuests.length; index++) {
          if (formData["fullName" + index]) {
            const guestData = {
              id: data.secondaryGuests[index].id,
              reservationId: data.id,
              name: formData["fullName" + index],
              vehiclePlate: formData["vehiclePlate" + index],
              document:
                formData["docType" + index] === 1
                  ? formData["docValue" + index]
                  : undefined,
              birthDate: formData["birthday" + index]
                ? masks.dataParaString(formData["birthday" + index])
                : null,
              email: formData["email" + index],
              phone: formData["phone" + index],
              image: removerBase64EAntes(
                formData.file.current["other-" + index]
              ),
              passport:
                formData["docType" + index] === 2
                  ? formData["docValue" + index]
                  : undefined,
            };
            submitData.push(guestData);
          }
        }

        call(null, api.renderAll(submitData), (response) => {
          if (response.ok) {
            setSuccess(true);
          }
        });
      } else {
        const guestData = {
          id: data.renterId,
          name: formData.fullName,
          document: formData.docType === 1 ? formData.docValue : undefined,
          birthDate: formData.birthday
            ? masks.dataParaString(formData.birthday)
            : null,
          email: formData.email,
          phone: formData.phone,
          image: removerBase64EAntes(formData.current.base),
          passport: formData.docType === 2 ? formData.docValue : undefined,
        };

        call(null, api.renderGuest(guestData), (response) => {
          if (response.ok) {
            setSuccess(true);
          }
        });
      }
    };
    submitCallback();
    /*
    alerts.setErrorModal(
      "Confirmação de Dados de Acesso",
      [
        "Ao continuar, você confirma os seus dados de acesso como usuário locatário e dados dos hóspedes acompanhantes. Deseja continuar?",
      ],
      HomeWork,
      [
        {
          label: "Sim, Confirmar",
          onClick: submitCallback,
        },
        {
          label: "Voltar",
          onClick: () => {
            errorModal.close();
          },
        },
      ]
    );*/
  };

  const onSubmitVisitant = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      const visitantData = {
        id: data.id,
        name: data.primaryGuest.name,
        cpf: data.primaryGuest.cpf,
        image: removerBase64EAntes(formData.current.base),
      };

      call(null, api.updateVisitant(visitantData), (response) => {
        if (response.ok) {
          setSuccess(true);
        }
      });
    };
    submitCallback();
  };

  const onSubmitSP = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      const spData = {
        id: data.id,
        name: data.serviceProvider.name,
        cnpj: data.serviceProvider.cnpj,
        image: removerBase64EAntes(formData.current.base),
      };

      call(null, api.updateSP(spData), (response) => {
        if (response.ok) {
          setSuccess(true);
        }
      });
    };
    submitCallback();
  };

  const onSubmitTenant = (formData) => {
    const submitCallback = () => {
      errorModal.close();
      const visitantData = {
        id: data.id,
        name: formData.name,
        cpf: formData.docValue,
        phone: formData.phone,
        email: formData.email,
        image: removerBase64EAntes(formData.current.base),
      };

      call(null, api.updateTenant(visitantData), (response) => {
        if (response.ok) {
          setSuccess(true);
        }
      });
    };
    submitCallback();
    /*
    alerts.setErrorModal(
      "Confirmação de Dados de Acesso",
      [
        "Ao continuar você confirma seus dados de acesso como inquilino. Deseja continuar?",
      ],
      HomeWork,
      [
        {
          label: "Sim, Confirmar",
          onClick: submitCallback,
        },
        {
          label: "Voltar",
          onClick: () => {
            errorModal.close();
          },
        },
      ]
    );*/
  };

  function DrawNormal(data) {

    if (data.renterId === data?.primaryGuest?.id) {
      return <ReservationForm onSubmit={onSubmit} data={data} />;
    } else {
     return <GuestForm onSubmit={onSubmit} data={data} />
    }
  }
  return (
    <>
      {loading ? (
        <StylesForm.ContainerExtra>
          <CircularProgress />
        </StylesForm.ContainerExtra>
      ) : success ? (
        <StylesForm.ContainerExtra>
          <CustomText fontSize={3}>Dados enviados com sucesso! 😊</CustomText>
        </StylesForm.ContainerExtra>
      ) : data ? (
        role === "NORMAL" ? (
          DrawNormal(data)
        ) : role === "GUEST" ? (
          <GuestForm onSubmit={onSubmit} data={data} />
        ) : role === "TENANT" ? (
          <TenantForm onSubmit={onSubmitTenant} data={data} />
        ) : role === "VISITANT" ? (
          <VisitantForm onSubmit={onSubmitVisitant} data={data} />
        ) : role === "SERVICE_PROVIDER" ? (
          <ServiceProviderForm onSubmit={onSubmitSP} data={data} />
        ) : 
          role === "ADMIN" ? (
          <ReservationFormADMIN onSubmit={onSubmit} data={data} />
        ) : (
          <div>???</div>
        )
      ) : (
        <StylesForm.ContainerExtra>
          <CustomText>Sem Dados</CustomText>
        </StylesForm.ContainerExtra>
      )}
    </>
  );
}

export default Home;
